import React from "react";
import ClientForm from "./form/ClientForm";
import { useManageClientContext } from "../../../context/ManageClientContex";

const CreateClientPage: React.FC = () => {
  const { clientPageOption , getClientOption } = useManageClientContext();
  React.useEffect(() => {
    if (!clientPageOption) {
      getClientOption();
    }
  }, [clientPageOption, getClientOption]);

  return <ClientForm />;
};

export default CreateClientPage;
